module.exports = __webpack_public_path__ + "img/16581309_L.bddfc373.png";